import { ManagerProfile } from '@/hooks';
import { buildLink } from '@/utils';

/* eslint-disable complexity */
export function isMenuItemActive(key: string, pathname: string) {
  return pathname.match(new RegExp(`^.*/${key}(?:/.*)?$`)) !== null;
}

export function createSettingsLink(manager: ManagerProfile) {
  let link = '';
  if (manager.rechte.tagebuch) {
    link = buildLink('einstellungenTagebuch');
  }
  if (link === '' && manager.hasUnrestrictedMitarbeiterRechte()) {
    link = buildLink('einstellungenQualifikationen');
  }
  if (link === '' && manager.rechte.arbeitszeit.erlaubt) {
    link = buildLink('einstellungenArbeitszeit');
  }
  if (link === '' && manager.rechte.kalender) {
    link = buildLink('einstellungenAbwesenheit');
  }
  if (
    link === '' &&
    (manager.rechte.abrechnung.export ||
      manager.rechte.abrechnung.monatsabschluss)
  ) {
    link = buildLink('einstellungenZuschlag');
  }
  if (link === '' && manager.isDienstplanAdmin()) {
    link = buildLink('einstellungenDienstplan');
  }
  return link;
}
